// config
import { ENV } from 'config';

export const BOD_VERSION = 11;

const BOD_URL_MAPPER: BodUrlMapper = {
  PROD: 'https://assets.upstox.com/prod-bod',
  QA: 'https://assets.upstox.com/prod-bod',
  UAT: 'https://assets.uat1.upstox.com/uat-live-bod',
};

export const BOD_URL: string = BOD_URL_MAPPER[ENV];
